import { connect } from 'react-redux';
import Sound from './sound';
import { setAlertSoundState } from '../reducers/app.reducers';

const mapStateToProps = state => ({
  shouldPlaySound:
    (state.app.shouldPlaySound &&
    !!state.app.options.playSoundForNewOrders) || state.orders.newOrderAlertOpen,
  repeatCount: state.app.localSettings.repeatCount,
  soundName: state.app.localSettings.soundName,
  loop: state.orders.newOrderAlertOpen,
});

const mapDispatchToProps = dispatch => ({
  stopPlaying: () => dispatch(setAlertSoundState(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sound);
